/** Modeling obtained from:
 * https://wiki.jetvision.de/wiki/Radarcape:Software_Features
 */

export enum GDAType {
  AIR = 'A',
  GROUND = 'G'
}

export enum AircraftColor {
  BLUE = '#0000FF',
  GRAY = '#808080',
  ORANGE = '#ffa500'
}

enum SourceType {
  ADSB = 'A',
  JETVISION_MLAT = 'M',
  FLIGHTAWARE_MLAT = 'F',
  OGN = 'O',
  FLARM = 'L'
}

export interface AircraftView {
  category: string;
  source: string;
  description: string;
  iconName: string;
  color?: string;
  size?: number;
  label?: string;
  extendedLabel?: string;
}

const DEFAULT_PLANE_IMG = 'plane.svg';

export const AIRCRAFTS_VIEW_DATA: AircraftView[] = [
  {
    category: 'A0', source: SourceType.ADSB, description: 'No category information', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'A1', source: SourceType.ADSB, description: 'Light (< 15500 lbs)', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'A2', source: SourceType.ADSB, description: 'Small (15500 >= lbs < 75000)', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'A3', source: SourceType.ADSB, description: 'Large (75000 >= lbs < 300000)', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'A4', source: SourceType.ADSB, description: 'Large (high vortex)', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'A5', source: SourceType.ADSB, description: 'Heavy (>= 300000 lbs)', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'A6', source: SourceType.ADSB, description: 'High performance', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'A7', source: SourceType.ADSB, description: 'Rotorcraft', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'B0', source: SourceType.ADSB, description: 'No category information', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'B1', source: SourceType.ADSB, description: 'Glider/Sailplane', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'B2', source: SourceType.ADSB, description: 'Lighter than air', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'B3', source: SourceType.ADSB, description: 'Parachutist/Skydiver', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'B4', source: SourceType.ADSB, description: 'Ultralight/Hang glider/Paraglider', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'B6', source: SourceType.ADSB, description: 'UAV', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'B7', source: SourceType.ADSB, description: 'Space/Trans-atmospheric vehicle', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'C0', source: SourceType.ADSB, description: 'No category information', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'C1', source: SourceType.ADSB, description: 'Surface vehicle - emergency', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'C2', source: SourceType.ADSB, description: 'Surface vehicle - service', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'C3', source: SourceType.ADSB, description: 'Obstacle - point', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'C4', source: SourceType.ADSB, description: 'Obstacle - clustter', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'C5', source: SourceType.ADSB, description: 'Obstacle - line', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F0', source: SourceType.FLARM, description: 'None', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F1', source: SourceType.FLARM, description: 'Glider/Motor glider', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F2', source: SourceType.FLARM, description: 'Tow/Tug plane', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F3', source: SourceType.FLARM, description: 'Helicopter/Rotorcraft', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F4', source: SourceType.FLARM, description: 'Skydiver', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F5', source: SourceType.FLARM, description: 'Skydiver/Drop plane', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F6', source: SourceType.FLARM, description: 'Hang glider', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F7', source: SourceType.FLARM, description: 'Paraglider', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F8', source: SourceType.FLARM, description: 'Aircraft reciprocating', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F9', source: SourceType.FLARM, description: 'Aircraft jet turboprop', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F11', source: SourceType.FLARM, description: 'Balloon', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F12', source: SourceType.FLARM, description: 'Airship', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F13', source: SourceType.FLARM, description: 'UAV', iconName: DEFAULT_PLANE_IMG,
  },
  {
    category: 'F15', source: SourceType.FLARM, description: 'Static', iconName: DEFAULT_PLANE_IMG,
  },
];
  /* If plane size is going to get changed, .svg file size should also be changed */
export const DEFAULT_VIEW_DATA: AircraftView = {
  category: 'Unknow',
  source: SourceType.ADSB,
  description: 'No category information',
  iconName: DEFAULT_PLANE_IMG,
  color: AircraftColor.GRAY,
  size: 30,
};

export interface ADSBPositions {
  /**
   * 0=no alert,
   * 1=temporary (Squawk changed previous 18s),
   * 2=mode-s alert,
   * 3=permanent (Squawk 7500,7600,7700).
   *
   * Since Mode-S DF4,5,20,21 do not distinguish between temporary and permanent alert,
   * the value 2 is used to mean either 1 or 3 and happens for non ADS-B A/C targets
  */
  alerts: number;
  longitude: number;
  latitude: number;
  icaocode: string;
  time: number;
  direction: number;
  altitude: number;
  gda: GDAType;
  ageLastPosition: number;
  origin: string;
  destination: string;
  source: string;
  category: string;
  modeS: string;
  flight: string;
  registration: string;
  verticalRate: number;
  speed: number;
  type: string;
  squawk: string;
  viewData?: AircraftView;
}

/**
 * Socket Models
 *
 */
export interface SocketData {
  id: number;
  type: string;
  message: any[];
  time: number;
}

export interface ServerToClientEvents {
  message: (message: SocketData) => void;
  ping: () => void;
}

export interface ClientToServerEvents {
  hello: () => void;
}

export const MESSAGE_TYPE = {
  ADS_B: 'ADS-B',
  ADSB_CONNECTION_ERROR: 'ADS-B Connection Error',
};
